// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-code-import-loader__panel{height:190px;position:relative}.ac-code-import-loader__progress{padding:1.5rem 2rem}.ac-code-import-loader .ac-loading-panel{display:flex}.ac-code-import-loader .ac-loading-panel__label{position:absolute;bottom:20px}.ac-code-import-loader .ac-panel__content{color:red;padding:2rem}\n", ""]);
// Exports
module.exports = exports;
